import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { CategoryService } from 'src/app/services/category';
import { LocaleService } from 'src/app/services/locale';
import { InputComponent } from '../../../../shared/input';
import { DropdownComponent } from '../../../../shared/dropdown';

@Component({
  selector: 'app-category1-question6',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputComponent,
    DropdownComponent
  ],
  template: `
    <form class="flex flex-col gap-6">
      <div>
        <div class="w-1/2 mb-2">
          {{ strings[language].reporting_boundary }}
        </div>
        <app-dropdown
          placeholder="{{ strings[language].reporting_boundary }}"
          [options]="[
            { label: strings[language].land_owned, value: 'land_owned' },
            { label: strings[language].org_ops, value: 'org_ops' },
            { label: strings[language].geo_region, value: 'geo_region' }
          ]"
          [control]="form.controls['reporting_boundary']"
        ></app-dropdown>
      </div>

      <div *ngIf="form.controls['reporting_boundary'].value === 'geo_region'">
        <div class="w-1/2 mb-2">
          {{ strings[language].region }}
        </div>
        <app-input
          [keyUp]="onChange"
          class="w-full"
          type="text"
          placeholder="{{ strings[language].region }}"
          [control]="form.controls['region']"
        ></app-input>
      </div>

      <div>
        {{ strings[language].land_use }}
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div class="flex gap-2 align-middle items-center cursor-pointer ">
          <input
            id="1"
            type="checkbox"
            [formControl]="form.controls['deforestation']"
            (change)="onChange()"
            class="w-4 h-4 accent-[#043B22] cursor-pointer"
          />
          <label for="1" class="cursor-pointer mt-[1px] text-[14px]">
            {{ strings[language].deforastion }}
          </label>
        </div>

        <div class="flex gap-2 align-middle items-center cursor-pointer ">
          <input
            id="2"
            type="checkbox"
            [formControl]="form.controls['land_conversion']"
            (change)="onChange()"
            class="w-4 h-4 accent-[#043B22] cursor-pointer"
          />
          <label for="2" class="cursor-pointer mt-[1px] text-[14px]">
            {{ strings[language].land_conversion }}
          </label>
        </div>

        <div class="flex gap-2 align-middle items-center cursor-pointer ">
          <input
            id="3"
            type="checkbox"
            [formControl]="form.controls['ag_ops']"
            (change)="onChange()"
            class="w-4 h-4 accent-[#043B22] cursor-pointer"
          />
          <label for="3" class="cursor-pointer mt-[1px] text-[14px]">
            {{ strings[language].ag_ops }}
          </label>
        </div>

        <div class="flex gap-2 align-middle items-center cursor-pointer ">
          <input
            id="4"
            type="checkbox"
            [formControl]="form.controls['forest_management']"
            (change)="onChange()"
            class="w-4 h-4 accent-[#043B22] cursor-pointer"
          />
          <label for="4" class="cursor-pointer mt-[1px] text-[14px]">
            {{ strings[language].forest_management }}
          </label>
        </div>
      </div>

      <div>
        <div class="w-1/2 mb-2">
          {{ strings[language].annual_emissions }}
        </div>
        <app-input
          [keyUp]="onChange"
          type="number"
          [dollar]="false"
          unit="{{ strings[language].unit }}"
          placeholder="0.00"
          class="w-full"
          type="number"
          placeholder="{{ strings[language].annual_emissions }}"
          [control]="form.controls['annual_emissions']"
        ></app-input>
      </div>
    </form>
  `
})
export class Category1Question6Component {
  language = inject(LocaleService).getLanguage();
  categoryService = inject(CategoryService);
  categories = this.categoryService.categories();

  form = new FormGroup({
    reporting_boundary: new FormControl('', Validators.required),
    region: new FormControl(''),
    deforestation: new FormControl(false),
    land_conversion: new FormControl(false),
    ag_ops: new FormControl(false),
    forest_management: new FormControl(false),
    annual_emissions: new FormControl('', Validators.required)
  });

  strings: any = {
    english: {
      reporting_boundary: 'Select the reporting boundary',
      land_owned: 'Land owned or controlled by the organization',
      org_ops:
        'Entire organization operations (including leased sites and areas)',
      geo_region: 'Specific geographic region or operating unit',
      region: 'Specify the region or operating unit',
      land_use: 'Land use activities within this boundary',
      deforastion: 'Deforestation',
      land_conversion: 'Land conversion',
      ag_ops: 'Agricultural operations',
      forest_management: 'Forest management',
      annual_emissions: 'Annual emissions',
      unit: 'tonnes CO2e',
      select: 'Select'
    },
    italian: {
      reporting_boundary: 'Seleziona il perimetro di rendicontazione',
      land_owned:
        "Terreni di proprietà o sotto il controllo dell'organizzazione",
      org_ops:
        "Operazioni dell'intera organizzazione (inclusi siti e aree in affitto)",
      geo_region: 'Regione geografica specifica o unità operativa',
      region: "Specifica la regione o l'unità operativa",
      land_use: "Attività di uso del suolo all'interno di questo perimetro",
      deforastion: 'Deforestazione',
      land_conversion: 'Conversione del suolo',
      ag_ops: 'Operazioni agricole',
      forest_management: 'Gestione forestale',
      annual_emissions: 'Emissioni annuali',
      unit: 'tonnellate CO2e',
      select: 'Seleziona'
    }
  };

  ngOnInit() {
    let categories = localStorage.getItem('categories');

    if (categories) {
      categories = JSON.parse(categories);
      //@ts-ignore
      if (categories?.[0]?.questions?.[5]?.answers) {
        // @ts-ignore
        this.form.setValue(categories?.[0]?.questions?.[5]?.answers);
      }
    }
  }

  onChange = async () => {
    // @ts-ignore
    this.categories[0].questions[5].answers = this.form.value;
    this.categoryService.persistCategories(this.categories);
  };
}
